// extracted by mini-css-extract-plugin
export default {"afterpayPlacement":"Y0-z"};